import { qryOrgBindSubsSummary, qryOrgBindSubsList, queryOrgStaffList, orgbindSubsAssign, qryRegionList, queryStaffList } from '@pages/AssignAreaToMembers/services';
import { getRequestData } from '@/utils';
// import get from 'lodash/get';

export default {
  namespace: 'assignMembersArea',
  state: {
    totalDetail: {},
    pageInfo: {
      pageIndex: 1,
      pageCount: 10,
    },
    total: 0,
    bindSubsList: [],
    staffDtoList: [],
    leafPageIndex: 0,
    leafPageSize: 0,
    regionDtoList: [],
    regionTotal: 0,
  },
  effects: {
    *qryOrgBindSubsSummary({ payload }, { call, put }) {
      const result = yield call(qryOrgBindSubsSummary, payload);
      const { total, assignedTotal, unassignedTotal } = getRequestData(result);
      yield put({
        type: 'save',
        payload: { totalDetail: { total, assignedTotal, unassignedTotal } },
      });
    },
    *qryOrgBindSubsList({ payload }, { call, put, select }) {
      const pageInfo = yield select(state => state.assignMembersArea.pageInfo);
      const result = yield call(qryOrgBindSubsList, payload);
      const { orgSubsBindRelaDtoList, pageDto = {} } = getRequestData(result);
      if (pageDto.pageIndex === 1) { // 只有第一页返回的总数才是真正的总数
        yield put({
          type: 'save',
          payload: {
            total: pageDto.totalRecord || 0,
          },
        });
      }
      yield put({
        type: 'save',
        payload: {
          bindSubsList: orgSubsBindRelaDtoList,
          pageInfo: {
            ...pageInfo,
            ...pageDto,
          },
        },
      });
    },
    *queryOrgStaffList({ payload }, { call, put }) {
      const result = yield call(queryOrgStaffList, payload);
      const { staffDtoList = [] } = getRequestData(result);
      yield put({
        type: 'save',
        payload: { staffDtoList },
      });
    },
    *queryStaffList({ payload }, { call }) {
      const result = yield call(queryStaffList, payload) || {};
      return result.data || {};
    },
    *orgbindSubsAssign({ payload }, { call }) {
      const result = yield call(orgbindSubsAssign, payload);
      return getRequestData(result);
    },
    *qryRegionList({ payload }, { call, put }) {
      const result = yield call(qryRegionList, payload);
      const res = getRequestData(result);
      yield put({
        type: 'save',
        payload: {
          leafPageIndex: payload.pageIndex,
          leafPageSize: payload.pageSize,
          regionTotal: res.totalCount,
          regionDtoList: res.regionDtoList || [],
        },
      });
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
